@if (event.participants.length) {
    @if (isEpcotEnabled) {
        <ng-container *ngTemplateOutlet="myBetsScoreBoard; context: { liveText: '', indicatorWithScore: true }"></ng-container>
    } @else {
        <ng-container *ngTemplateOutlet="myBetsScoreBoard; context: { liveText: liveText, indicatorWithScore: false }"></ng-container>
    }
} @else {
    <div class="mybets-scoreboard_players">
        <div class="cell">{{ event.name }}</div>
        <div class="cell"><ms-my-bets-scoreboard-time [vm]="baseScoreboardViewModel.getEventTimeViewModel()"></ms-my-bets-scoreboard-time></div>
    </div>
}

<ng-template #myBetsScoreBoard let-liveText="liveText" let-indicatorWithScore="indicatorWithScore">
    @if (isLive() && showLiveIndicator()) {
        <span class="mybets-scoreboard_info-live-badge"> {{ liveText }} </span>
    }
    <ng-container *ngTemplateOutlet="myBetsPlayersScore"></ng-container>
    @if (indicatorWithScore) {
        <span class="serving-indicator"></span>
        @if (isLive()) {
            <span class="mybets-condensed-scoreboard_score-value" [innerHtml]="totalsScore"></span>
        }
    }
    <div class="mybets-condensed-scoreboard_time">
        @if (!indicatorWithScore) {
            <span class="serving-indicator"></span>
        }
        <ms-my-bets-scoreboard-time
            class="my-bets-scoreboard-timer"
            [vm]="baseScoreboardViewModel.getEventTimeViewModel()"
            [hideLiveBadge]="true"></ms-my-bets-scoreboard-time>
    </div>
</ng-template>

<ng-template #myBetsPlayersScore>
    <span class="mybets-condensed-scoreboard_players-name"> {{ homePlayer }} </span>
    @if (showAwayIndicator()) {
        <span class="mybets-scoreboard_players-away-indicator">{{ sitecore.globalMessages.AwayIndicator }}</span>
    }
    @if (isLive() && !isEpcotEnabled) {
        <span class="mybets-condensed-scoreboard_score-value" [innerHtml]="totalsScore"></span>
    }
    <span class="mybets-condensed-scoreboard_players-name"> {{ awayPlayer }} </span>
</ng-template>
